import * as React from 'react';
import Box from '@mui/material/Box';
import { useMatomo } from '@datapunt/matomo-tracker-react';
import { useLocation } from 'react-router-dom';

import Wastunwir from './general/Wastunwir';
import UnserAng from './general/UnserAng';
import UnserAngDien from './general/UnsAngDien';
import Tours from './general/Tours';

import mainImage from '../../images/service/NiG Schaugarten.jpg';

export default function Dienstleistungen() {

  const { trackPageView  } = useMatomo() // trackEvent
  const location = useLocation();
    
  // Track page view
  React.useEffect(() => {
    trackPageView({
      documentTitle: 'Dienstleistungen', // optional
      href: 'https://naturimgarten.laimburg.it' + location.pathname, // optional
      customDimensions: [
        {
          id: 1,
          value: 'loggedIn',
        },
      ], // optional
    })
  }, [trackPageView])

  return (
    <Box>

      <Box className='mainimagebox' >
        <img className='mainimage'
          src={mainImage}
          alt="placeholder"
          width='100%'
        />
      </Box>

      <Wastunwir />

      <UnserAngDien />

      <UnserAng />

      <Tours />

    </Box>
  );
}
